/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Tab_RepliedInputs */

const en_admin_tickets_tab_replied = /** @type {(inputs: Admin_Tickets_Tab_RepliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Progress`)
};

/**
* | output |
* | --- |
* | "In Progress" |
*
* @param {Admin_Tickets_Tab_RepliedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_tickets_tab_replied = /** @type {((inputs?: Admin_Tickets_Tab_RepliedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Tab_RepliedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_tickets_tab_replied(inputs)
});
export { admin_tickets_tab_replied as "admin.tickets.tab_replied" }